import { TABLES_KEYS } from 'features/ai-generators/constants';

export const PAGE_KEY = TABLES_KEYS.savedSearches;
export const SAVED_SEARCH_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'name',
    label: 'Search Name',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'description',
    label: 'Description',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'search',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'updatedAt',
    label: 'Last Update',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdAt',
    label: 'Created At',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'updatedAt',
  direction: 'desc'
};
